import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { AcceptTermsPage } from 'components/pages';
import AutoLogout from 'components/AutoLogout';
import AppDataLoader from 'components/AppDataLoader';

function PrivateRoute({ element, isAuthenticated, showAgreement, children }) {

  // Ensure boolean value for showAgreement
  if (typeof showAgreement === 'string') {
    showAgreement = showAgreement.toLowerCase() === 'true';
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (showAgreement) {
    return (
      <>
        <AutoLogout />
        <AppDataLoader />
        <AcceptTermsPage />
      </>
    );
  }

  return (
    <>
      <AutoLogout />
      <AppDataLoader />
      {element || children || <Outlet />}
    </>
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  element: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  isAuthenticated: PropTypes.bool.isRequired,
  showAgreement: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default PrivateRoute;
